import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import BackEnd from "../../../../backend/BackEnd";
import {registerMetricaEvent} from "../../../../utils/metrica";

class AdvertContactsModal extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };
    static defaultProps = {};
    state = {
        isLoading: false,
        phoneNumber: ''
    };
    getContacts = new BackEnd.Adverts.Contacts(this);

    async componentWillReceiveProps({show, data}) {
        if (show) {
            const {advertId} = data;

            let contacts = await this.getContacts.call({advertId});

            this.setState({...contacts});
            registerMetricaEvent('ad_open_contacts');
        }
    }

    render() {
        const {data, ...props} = this.props;
        return (
            <Modal {...props} className="modal-alert modal-success" bsSize="small">
                <Modal.Header>
                    <i className="fa fa-phone"/>
                </Modal.Header>
                <Modal.Body>
                    <div className="font-size-28">
                        <strong>{this.state.phoneNumber}</strong>
                    </div>
                    <div className="font-size-20">
                        {data.creatorName}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" class="btn btn-success"
                            onClick={() => props.onHide()}>
                        OK
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default AdvertContactsModal;


// WEBPACK FOOTER //
// ./src/pages/Adverts/AdvertList/modals/AdvertContactsModal.js